import { Divider, Grid, MenuItem, Paper, Typography } from '@material-ui/core';

import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { Select, TextField } from 'modules/intake/form';
import { sortCountriesUsFirst } from 'modules/enumerations/enumerationHelpers';

const activeOptions = (options) => (options || []).filter((option) => option.isActive !== false);

// One family member's Visa/Immigration fields on the intake form: a one-to-one copy of the
// Visa/Immigration card on the authorization's Global service.
const GlobalVisaInfoCard = ({ visaInfo, index, contact, enumerations, handleChange, handleBlur }) => {
  const prefix = `globalService.visaInfos.${index}`;
  const visaStatuses = activeOptions(enumerations.visaStatuses);
  const visaTypes = activeOptions(enumerations.visaTypes);
  const countries = sortCountriesUsFirst(activeOptions(enumerations.countries));

  const renderDateField = (name, label, value) => (
    <Grid item xs={12} md={3}>
      <Field component={TextField} name={name} label={label} value={value} onChange={handleChange} onBlur={handleBlur} type="date" fullWidth />
    </Grid>
  );

  const renderTextField = (name, label, value) => (
    <Grid item xs={12} md={3}>
      <Field component={TextField} name={name} label={label} value={value} onChange={handleChange} onBlur={handleBlur} fullWidth />
    </Grid>
  );

  const renderSelectField = (name, label, value, options, labelWidth) => (
    <Grid item xs={12} md={3}>
      <Field
        component={Select}
        name={name}
        label={label}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        labelWidth={labelWidth}
        fullWidth
      >
        <MenuItem value=""><em>None</em></MenuItem>
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>
        ))}
      </Field>
    </Grid>
  );

  return (
    <Paper classes={{ root: 'card-root' }} className="mb-2">
      <Typography variant="h4" gutterBottom>{contact ? `${contact.firstName} ${contact.lastName}` : 'Family Member'}</Typography>
      <Grid container spacing={1}>
        {renderSelectField(`${prefix}.visaStatusId`, 'Visa Status', visaInfo.visaStatusId, visaStatuses, 85)}
        {renderSelectField(`${prefix}.currentVisaId`, 'Current Visa', visaInfo.currentVisaId, visaTypes, 90)}
        {renderDateField(`${prefix}.visaExpiredDate`, 'Visa Expiry Date', visaInfo.visaExpiredDate)}
        {renderDateField(`${prefix}.visaMaxDate`, 'Visa Max Date', visaInfo.visaMaxDate)}
        {renderSelectField(`${prefix}.visaIssuedById`, 'Visa Issued By', visaInfo.visaIssuedById, countries, 105)}
        {renderTextField(`${prefix}.visaDocumentNumber`, 'Visa Document Number', visaInfo.visaDocumentNumber)}
        {renderDateField(`${prefix}.visaInterviewDate`, 'Interview Date', visaInfo.visaInterviewDate)}
        {renderTextField(`${prefix}.visaConsulate`, 'Consulate', visaInfo.visaConsulate)}
        {renderTextField(`${prefix}.visaReceiptNumber`, 'Receipt Number', visaInfo.visaReceiptNumber)}
        {renderDateField(`${prefix}.visaTravelToDate`, 'Travel To Date', visaInfo.visaTravelToDate)}
        <Grid item xs={12}>
          <Divider variant="fullWidth" className="full-width" />
        </Grid>
        {renderTextField(`${prefix}.passportNumber`, 'Passport Number', visaInfo.passportNumber)}
        {renderDateField(`${prefix}.passportReceivedDate`, 'Passport Received', visaInfo.passportReceivedDate)}
        {renderDateField(`${prefix}.passportExpiredDate`, 'Passport Expiry', visaInfo.passportExpiredDate)}
      </Grid>
    </Paper>
  );
};

GlobalVisaInfoCard.propTypes = {
  visaInfo: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  contact: PropTypes.object,
  enumerations: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
};

export default GlobalVisaInfoCard;
